import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import type { NextPage } from 'next'
import { KPI, Map, Seo, Spinner, TabSection } from '../components'

const Home: NextPage = () => {
  const { user, isLoading } = useAuth0()
  if (isLoading) return <Spinner />

  if (user != undefined)
    return (
      <>
        <Seo title="Home" />
        <Grid
          container
          minHeight="calc(100vh - 95px)"
          mt={'72px'}
          display="flex"
          justifyContent="flex-start"
        >
          <Grid
            item
            container
            xs={12}
            md={8}
            lg={9}
            xl={10}
            order={{ xs: 2, md: 1 }}
          >
            <Grid item xs={12}>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  '& > :not(style)': {
                    width: '100%',
                    minHeight: '50vh',
                  },
                }}
              >
                <Paper square elevation={1}>
                  <Map />
                </Paper>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  '& > :not(style)': {
                    width: '100%',
                    minHeight: '50vh',
                  },
                }}
              >
                <Paper square elevation={1}>
                  <TabSection />
                </Paper>
              </Box>
            </Grid>
          </Grid>
          <Grid item xs={12} md={4} lg={3} xl={2} order={{ xs: 1, md: 2 }}>
            <KPI />
          </Grid>
        </Grid>
      </>
    )

  return <></>
}

export default withAuthenticationRequired(Home)
